import React, { useState,useEffect } from 'react'
import { Button, Input, Select, Table ,Checkbox ,} from "antd";
import "aos/dist/aos.css";
import { Navigate, useParams } from "react-router-dom";
import "../MainCSS.css";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import { Option } from 'antd/es/mentions';
import DataTable from 'react-data-table-component'; // DataTable library
import { DeleteDataOrderAllot, GetByOrderNumber, GetJobSheetApprovalList, GetJobSheetBulkApproval, GetJobSheetByOrderNumber } from '../../AllAPI/SalesAPI/SalesApi';

const JobSheetApprovalDetails = () => {
      const navigate = useNavigate();
      const { orderId } = useParams();
      console.log("Order id",orderId);
  const [orderInfo, setOrderInfo] = useState(null);
       const commonHeaders = {
    headers: {
      createdBy: 1,
      updatedBy: 2,
      userIp: '',
      userLat: '',
      userLong: '',
      deviceSign: '',
    },
  };
 const [errors, setErrors] = useState({
       selectedId:"",

      });
    
  const goodTypesOptions = [
    { value: '1', label: 'F.T' },
    { value: '2', label: 'MM' },
    { value: '3', label: 'Inch' },
  ]
  const [allOrders, setAllOrders] = useState([]);
  const [selectedOrder, setSelectedOrder] = useState("");
  const [orderItems, setOrderItems] = useState([]);
  const [approvedItems, setApprovedItems] = useState(new Set());
  const [selectAll, setSelectAll] = useState(false);
  const[selectedId , setSelectedId]=useState("");

  const[orderPass , setOrderPass]=useState(false);

   const [pageSize, setPageSize] = useState(10);
        const [filteredData, setFilteredData] = useState([]);
        const [currentPage, setCurrentPage] = useState(1);
        const [totalEntries, setTotalEntries] = useState(0);
        const [isBulkSelecting, setIsBulkSelecting] = useState(false);


   //======Search data from table===============
    const handleSearch = (value) => {
      const searchValue = value.toLowerCase();
  
      const filtered = orderItems.filter((item) =>
        Object.values(item).some((val) =>
          String(val ?? "").toLowerCase().includes(searchValue)
        )
      );

      setFilteredData(filtered);
      setTotalEntries(filtered.length); // Update total entries count after filtering
      setCurrentPage(1);
    };
  //==========Pagination=======================
  const handlePageSizeChange = (value) => {
    setPageSize(value);
  };
 
//   useEffect(() => {
//   const savedData = localStorage.getItem("selectedOrderData");
//   if (savedData) {
//     const { orderInfo, selectedItems } = JSON.parse(savedData);
//     setSelectedOrder(orderInfo);
//     setOrderItems(selectedItems);
//     //  setFilteredData(orderItems);   // << Add this line
//     // setTotalEntries(orderItems.length); // Also update total entries
//   }
// }, []);
// console.log("Selected Order",selectedOrder);
// console.log("Order Items",orderItems);
//=========================== Getting AUTH TOken from session storage ============================================================================
   useEffect(() => {
  const userData = sessionStorage.getItem("authToken");
  console.log("User Data",userData);
  if (!userData) {
    navigate("/login");
  }
}, []); 
  
useEffect(() => {
       console.log("useEffect triggered");
  console.log("useEffect triggered, orderId:==>>", orderId); // Add this line

//fetchJobSheetData();
  fetchOrderData(orderId);
 
}, [orderId]); 
//   const fetchJobSheetData = async () => {
//     try {
//      // const response = await axios.get("http://192.168.29.1getJobSheetApprovalList16:8182/sales/JobSheetApproval/getJobSheetApprovalList",commonHeaders);
//      const response = await axios.get(GetJobSheetApprovalList,commonHeaders);
//       setAllOrders(response.data); // assuming the API returns an array
//           const order = allOrders.find(o => o.id === parseInt(orderId)); // Make sure the orderId is a number
//     setSelectedOrder(order);
//        console.log("Selected Order",selectedOrder);
//  //console.log("Common Order Data",commonOrderData);
//     } catch (error) {
//       console.error("Error fetching Job Sheet data:", error);
//       toast.error("Error fetching Job Sheet data");
//     }
//   };
  const fetchOrderData = async (orderId) => {

     
  if (!orderId) {
    toast.error("No orderId found in URL");
    return;
  }
  
    try {
        const response = await axios.get(
               `${GetJobSheetByOrderNumber}?orderNumberId=${orderId}`,
               commonHeaders
             );
      console.log("API response:===>", response.data); // Check API response

      const orderDetails = response.data;

    if (orderDetails && orderDetails.length > 0) {
      // Assuming that the first object contains the order data you're looking for
      const order = orderDetails[0];  // Adjust this if you need a specific order from the response

      // // Extract the common order data
      const commonOrderData = {
        orderNumber: order.orderNumber,
        poNumber: order.poNumber,
        customerName: order.customerName,
        poDate: order.poDate,
        entryDate: order.entryDate,
        // Add any other common fields you need here
      };

      // // Set the extracted common order data to the state
       setSelectedOrder(commonOrderData);// Set order details
        setOrderItems(orderDetails);  // Assuming items are part of the response
        setFilteredData(orderDetails);  // Also set the filtered data initially
        setTotalEntries(orderDetails.length);
         console.log("Selected Order",selectedOrder);
 console.log("Common Order Data",commonOrderData);
            //  const order = allOrders.find(o => o.id === parseInt(orderId)); 
            // setSelectedOrder(order); 
            // console.log("Selected Order",selectedOrder);//something is wrong

      } else {
        toast.error("Order not found.");
      }
    } catch (error) {
      console.error("Error fetching order data:", error);
      toast.error("Error occurred while fetching order details.");
    }
  };
  useEffect(() => {
    if (selectedOrder) {
      console.log("Selected Order Updated:", selectedOrder);
    }
  }, [selectedOrder]);
  // const handleOrderSelect = async (orderId) => {
  //   const order = allOrders.find((o) => o.id === orderId);
  //   setSelectedOrder(order); 
  // };
  const toggleItemSelection = (itemId, isChecked) => {
    setApprovedItems((prev) => {
      const updated = new Set(prev);
      isChecked ? updated.add(itemId) : updated.delete(itemId);
  
      setIsBulkSelecting(updated.size > 1);
      return updated;
    });
  };
  
  const handleItemApproval = async (itemId , currentJobStatus) => {
    if (approvedItems.has(itemId)) {
      const newJobStatus = currentJobStatus === 0 ? 1 : (currentJobStatus === 1 ? 2 : 1);
            await approveItems([itemId],newJobStatus); // Wrap single ID in array
    } else {
      toast.warn("Please select the checkbox before approving.");
    }
  };
  
 
  
  const handleBulkApprove = async () => {
    const idsToApprove = Array.from(approvedItems);
  
    if (idsToApprove.length > 0) {
      const selectedStatuses = orderItems
        .filter((item) => approvedItems.has(item.id))
        .map((item) => item.jobStatus);
        
        const allApproved = selectedStatuses.every((status) => status === 1);
        const newStatus = allApproved ? 2 : 1;

  
      await approveItems(idsToApprove, newStatus);
  
      setApprovedItems(new Set());
      setSelectAll(false);
      setIsBulkSelecting(false);
      
    } else {
      toast.warn("No items selected for bulk action.");
    }
  };
     
    //========================================= For Bulk Approval /Rejection Button =====================================
    const selectedStatuses = orderItems
    .filter((item) => approvedItems.has(item.id))
    .map((item) => item.jobStatus);
  
  const bulkActionType = selectedStatuses.length > 0 && selectedStatuses.every((status) => status === 1)
    ? "reject"
    : "approve";
  
  const buttonText = bulkActionType === "approve" ? "Approve Selected Items" : "Reject Selected Items";
  const buttonColor = bulkActionType === "approve" ? "#28a745" : "#dc3545";
  //=======================================================================================
  
//   const approveItems = async (orderNumberIds ,jobStatus) => {
//     const requestBody ={
//         id : orderNumberIds,
//         jobStatus:1,
//     }
//     // const requestBody = orderNumberIds.map((orderNumber) => ({
//     //   finalOrderNumber: orderNumber,  
//     //   orderNumberId: selectedId,     
//     //   itemApproval: 1 ,               
//     // }));
// const queryString = orderNumberIds.map(id => `ids=${id}`).join('&');

//     try {
//       const response = await axios.post(
//        `${GetJobSheetBulkApproval}?ids=${orderNumberIds}&jobStatus=${jobStatus}`,null,commonHeaders
//       // `${GetJobSheetBulkApproval}?${queryString}&jobStatus=${jobStatus}`,{},commonHeaders
      
//       );
  
//       if (response.data === "OK") {
//         const action = jobStatus === 1 ? "Approved" : "Rejected";
//         toast.success(`${action} successfully!`);
//          fetchOrderData(orderId);
//         // setSelectedOrder(null);
//         // setOrderItems([]);
//         // setApprovedItems(new Set());
//         // fetchJobSheetData();
       
//       } else if (response.data === "alreadyexisted") {
//         toast.warn("Item(s) already approved!");
//       }
//     } catch (error) {
//       console.error("Error during approval:", error);
//       toast.error("Error occurred while approving item(s)");
//     }
//   };
 const deleteOrderAllotmentItem = async (itemId) => {
  try {
    await axios.delete(`${DeleteDataOrderAllot}?id=${itemId}`, commonHeaders); 
    console.log(`Item ${itemId} deleted from order allotment`);
  } catch (error) {
    console.error(`Failed to delete item ${itemId} from order allotment`, error);
    toast.error("Failed to delete item from order allotment");
  }
};

const approveItems = async (orderNumberIds, jobStatus) => {
  try {
    const response = await axios.post(
      `${GetJobSheetBulkApproval}?ids=${orderNumberIds}&jobStatus=${jobStatus}`,
      null,
      commonHeaders
    );

    if (response.data === "OK") {
      const action = jobStatus === 1 ? "Approved" : "Rejected";
      toast.success(`${action} successfully!`);
      fetchOrderData(orderId);

      // If rejected, delete each item from order allotment
      // if (jobStatus === 2) {
      //   for (const itemId of orderNumberIds) {
      //     await deleteOrderAllotmentItem(itemId);
      //   }
      // }

    } else if (response.data === "alreadyexisted") {
      toast.warn("Item(s) already approved!");
    }
  } catch (error) {
    console.error("Error during approval:", error);
    toast.error("Error occurred while approving item(s)");
  }
};
 

  const handleSelectAll = (e) => {
    const checked = e.target.checked;
    setSelectAll(checked);
    setIsBulkSelecting(checked); // update bulk selecting state
    if (checked) {
      const allIds = orderItems.map((item) => item.id);
      setApprovedItems(new Set(allIds));
    } else {
      setApprovedItems(new Set());
    }
  };
       const components = {
            header: {
              cell: ({ children, ...restProps }) => (
                <th
                  {...restProps}
                  style={{
                    backgroundColor: "#023e7d",
                    color: "#fff",
                    padding: "10px",
                    fontSize: "15px",
                    borderRadius: "0px",
                  }}
                >
                  {children}
                </th>
              ),
            },
            body: {
              row: ({ children, ...restProps }) => (
                <tr
                  {...restProps}
                  style={{
                    backgroundColor: "#f0f7fd",
                  }}
                >
                  {children}
                </tr>
              ),
              cell: ({ children, ...restProps }) => (
                <td
                  {...restProps}
                  style={{
                    padding: "8px",
                fontSize: '15px',
                  }}
                >
                  {children}
                </td>
              ),
            },
          };
    const columns = [
      {
        title: "Sr. No",
        key: "serial",
        render: (text, record, index) => (currentPage - 1) * pageSize + index + 1,
      },
      {
        title: "Item Entry Date",
        dataIndex: "itemEntryDate",
        key: "itemEntryDate",
        sorter: (a, b) =>
          new Date(a.itemEntryDate ?? '1970-01-01') - new Date(b.itemEntryDate ?? '1970-01-01'),
        render: (date) => {
          if (!date) return "-";
          const [year, month, day] = date.split("-");
          return `${day}/${month}/${year}`;
        },
      },
      {
        title: "Item Name",
        dataIndex: "dieName",
        key: "dieName",
        sorter: (a, b) => (a.dieName ?? "").localeCompare(b.dieName ?? ""),
      },
      {
        title: "Alloy",
        dataIndex: "alloyname",
        key: "alloyname",
        sorter: (a, b) => (a.alloyname ?? "").localeCompare(b.alloyname ?? ""),
      },
      {
        title: "Temper",
        dataIndex: "temperName",
        key: "temperName",
        sorter: (a, b) => (a.temperName ?? "").localeCompare(b.temperName ?? ""),
      },
      {
        title: "Wt./R",
        dataIndex: "weightRange",
        key: "weightRange",
            render: (text) => <div style={{ textAlign: 'right' }}>{text}</div>,
    
        sorter: (a, b) => (a.weightRange ?? "").localeCompare(b.weightRange ?? ""),
      },
      // {
      //   title: "Length",
      //   dataIndex: "length",
      //   key: "length",
      //       render: (text) => <div style={{ textAlign: 'right' }}>{text}</div>,
    
      //   sorter: (a, b) => (a.length ?? 0) - (b.length ?? 0),
      // },
        {
    title: 'Length',
    dataIndex: 'length',
    key: 'length',
    sorter: (a, b) => {
      const descA = a.length ?? 0;
      const descB = b.length ?? 0;
      return descA - descB;
    },
    render: (text, record) => {
      let unitLabel = '';
      if (record.unit === 1) unitLabel = '(FT)';
      else if (record.unit === 2) unitLabel = '(MM)';
      else if (record.unit === 3) unitLabel = '(Inch)';
      return `${record.length} ${unitLabel}`;
    },
  },
      {
        title: "Pcs",
        dataIndex: "pcs",
        key: "pcs",
            render: (text) => <div style={{ textAlign: 'right' }}>{text}</div>,
    
        sorter: (a, b) => (a.pcs ?? 0) - (b.pcs ?? 0),
      },
      {
        title: "Quantity (Kgs.)",
        dataIndex: "qty",
        key: "qty",
            render: (text) => <div style={{ textAlign: 'right' }}>{text}</div>,
    
        sorter: (a, b) => (a.qty ?? 0) - (b.qty ?? 0),
      },
      {
        title: "Item Approval",
        dataIndex: "jobStatus",
        key: "jobStatus",
        sorter: (a, b) => (a.jobStatus ?? 0) - (b.jobStatus ?? 0),
        render: (jobStatus) => {
          if (jobStatus === 1) return "Approved";
          if (jobStatus === 2) return "Rejected";
          return "Pending";
        },
      },
      {
        title: (
          <span>
            Select All <Checkbox checked={selectAll} onChange={handleSelectAll} />
          </span>
        ),
        key: "select",
        render: (_, record) => (
           <div
        style={{
          display: 'inline-block',
          padding: '4px',
          borderRadius: '4px',
          backgroundColor: '#023e7d', // Always highlight
        }}
      >
          <Checkbox
            checked={approvedItems.has(record.id)}
            onChange={(e) => toggleItemSelection(record.id, e.target.checked)}
          /></div>
        ),
      },
      {
        title: "Approve",
        key: "approve",
        render: (_, record) => (
          <Button
            style={{
              backgroundColor: record.jobStatus === 1 ? "#dc3545" : "#007bff",
              color: "#fff",
            }}
            onClick={() => handleItemApproval(record.id, record.jobStatus)}
          >
            {record.jobStatus === 1 ? "Reject" : "Approve"}
          </Button>
        ),
      },
    ];
   return (
    <div className="px-5 py-3" style={{ fontSize: "15px" }}>
 <div  className="row mt-3 p-3 pb-5 pt-3 mb-3 rounded" style={{ backgroundColor: '#e0efff' ,minHeight: '800px'  }}>
          
  <div className="col-12">


    <div className="p-0 m-0">
   <div className="row px-md-5 mt-3 p-2">
      <div className="row p-0 m-0">
        <div className="col-12 col-lg-4"></div>
      
        <div className="col-12 col-lg-4"></div>
      </div>


       
          <div className="shadow border p-4 mb-4" style={{ backgroundColor: "#f8f9fa", fontSize: "15px"}}>
          <div className="order-summary my-3 px-4">
  <h6 className="mb-3" style={{fontSize: "21px",fontWeight:"bold"}}>Order Details:</h6>
  <div className="container-fluid">
    <div className="row" style={{fontSize: "17px"}}>
      <div className="col-md-4">
        <div className="d-flex mb-3"  style={{fontSize: "17px"}}>
          <span style={{ minWidth: "110px", marginRight: "10px" }}>Order Number:</span>
          <strong> {selectedOrder.orderNumber}</strong>
        </div>
        <div className="d-flex">
          <span style={{ minWidth: "110px", marginRight: "10px" }}>PO No.:</span>
          <strong>{selectedOrder.poNumber}</strong>
        </div>
      </div>

      {/* Right column */}
       <div className="col-md-4">
        
          <div className="d-flex mb-3"  style={{fontSize: "17px"}}>
          <span style={{ minWidth: "130px", marginRight: "10px" }}>Order Entry Date:</span>
          <strong>{selectedOrder.entryDate}</strong>
        </div>
        <div className="d-flex">
          <span style={{ minWidth: "130px", marginRight: "10px" }}>Customer:</span>
          <strong>{selectedOrder.customerName}</strong>
        </div>
      </div>
      <div className="col-md-4">
        <div className="d-flex mb-3"  style={{fontSize: "17px"}}>
          <span style={{ minWidth: "130px", marginRight: "10px" ,fontSize: "17px" }}>PO Date:</span>
          <strong   style={{fontSize: "17px"}}>{selectedOrder.poDate}</strong>
        </div>
</div>
    </div>
  </div>
</div></div>
          
    
      </div>

      {/* Table */}
      
         <div className="row m-0 p-2  px-md-5 pt-md-0 mt-3">
               <div className="col-12 py-3 shadow border" style={{  backgroundColor: "white" }}>
                 <div className="col-12 px-md-5" style={{ display: "flex", justifyContent: "space-between" }}>
                   <div>
                     <span style={{ fontSize: "14px" }}>Show entries &nbsp;</span>
                     <Select
                       defaultValue={pageSize}
                       onChange={handlePageSizeChange}
                       style={{ width: 120, textAlign: "center" }}
                     >
                       <Option value={10}>10</Option>
                       <Option value={20}>20</Option>
                       <Option value={30}>30</Option>
                     </Select>
                       {/* <div>
          Show{" "}
          <Select
            value={pageSize}
            onChange={(value) => setPageSize(value)}
            style={{ width: 80 }}
          >
            {[5, 10, 15, 20, 25, 50].map((size) => (
              <Option key={size} value={size}>
                {size}
              </Option>
            ))}
          </Select>{" "}
          entries
        </div> */}
                   </div>
           
                   <div className="pt-4 pt-md-0">
                     <Input.Search
                       placeholder="Search"
                        onChange={(e) => handleSearch(e.target.value)}
                       style={{ width: 200, marginBottom: 16 }}
                     />
                   </div>
                 </div>
           
                 <div style={{ backgroundColor: "white" }}>
                   <Table
                     bordered
                     style={{ padding: "0px 20px", overflowX: "auto" }}
                     columns={columns}
                     dataSource={filteredData}
                     pagination={{
                       pageSize: pageSize,
                       total: totalEntries,
                       showTotal: (total, range) =>
                         `Showing ${range[0]} to ${range[1]} of ${total} entries`,
                       current: currentPage,
                       onChange: (page) => setCurrentPage(page),
                     }}
                     showSorterTooltip={false}
                     rowKey={(record) => record.id}
                     components={components}
                         summary={(pageData) => {
                                let totalQty = 0;
                                let totalPcs = 0;

                                pageData.forEach(({ qty, pcs }) => {
                                  totalQty += Number(qty) || 0;
                                  totalPcs += Number(pcs) || 0;
                                });

                                return (
                                  <Table.Summary.Row style={{ backgroundColor: "#e1ecf4", }}>
                                    <Table.Summary.Cell index={0} colSpan={5} />
                                    <Table.Summary.Cell index={5} />        
                                    <Table.Summary.Cell index={6} />
                                    <Table.Summary.Cell index={7}>Total Pcs: <span style={{fontWeight: "bold"}}>{totalPcs}</span></Table.Summary.Cell>
                                    <Table.Summary.Cell index={8} >Total Qty: <span style={{fontWeight: "bold"}}>{totalQty}</span></Table.Summary.Cell>
                                    <Table.Summary.Cell index={9} />
                                    <Table.Summary.Cell index={11} />
                                    <Table.Summary.Cell index={12} />
                                   
                                  </Table.Summary.Row>
                                );
                              }}

                   />
{/* <DataTable
  columns={columns1}
  data={filteredData}
  pagination
  paginationPerPage={pageSize}

  onChangePage={(page) => setCurrentPage(page)}
    paginationRowsPerPageOptions={[5, 10, 15, 20, 25, 50]} // optional
  onChangeRowsPerPage={(newPageSize) => {
    setPageSize(newPageSize);
    setCurrentPage(1); // reset to first page when page size changes
  }}
  paginationTotalRows={filteredData.length}
  highlightOnHover
  striped
  responsive
  customStyles={{
    headCells: {
      style: {
        backgroundColor: "#023e7d",
        color: "#fff",
        padding: "10px",
        fontSize: "14px",
      },
    },
    rows: {
      style: {
        backgroundColor: "#f0f7fd",
        fontSize: "14px",
      },
    },
    cells: {
      style: {
        padding: "8px",
      },
    },
  }}
/> */}

                 </div>

                 {isBulkSelecting && approvedItems.size > 1 && (
  <div className="text-center px-md-5 mb-3">
    <Button
      onClick={handleBulkApprove}
      style={{
        backgroundColor: buttonColor,
        borderColor: buttonColor,
        color: "#fff",
      }}
    >
      {buttonText}
    </Button>
  </div>
)}

               </div>
               <div className="text-center pt-3">
              <Button
                 type="submit"
                className="CancelBtn mx-1"
                onClick={() => {
                  setOrderInfo(null);
                  setOrderItems([]);
                  setApprovedItems(new Set());
                    window.close(); 
                   navigate('/sales4',{ state: { refresh: true } }); 
                 // fetchJobSheetData();
                }}
              >
               Back to Page
              </Button>
            </div>
             </div>
      
     
    </div>
    </div></div></div>
  );
}

export default JobSheetApprovalDetails